/* eslint-disable no-unused-vars */
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const ACCOUNTING_ACCOUNTS_ACTION_TYPE = createNamedActions('accountingAccounts', {
  GET_ACCOUNTS: 'GET_ACCOUNTS',
});

export const getAccountingAccountsAction = catchAsyncActionError(params => async dispatch => {
  // const { data } = await accountingApi.getAccounts(params);
  // return dispatch({
  //   type: ACCOUNTING_ACCOUNTS_ACTION_TYPE.GET_ACCOUNTS,
  //   payload: data,
  // });
});
